'use client'

import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'

import { cn } from '@/lib/utils'

// Define the props type using ComponentPropsWithRef for React 19 style ref handling.
// This type automatically includes the 'ref' prop correctly typed.
type CheckboxProps = React.ComponentPropsWithRef<typeof CheckboxPrimitive.Root>

// Define the component as a standard function component.
// 'ref' is now destructured directly from the props object.
const Checkbox = ({ className, ref, ...props }: CheckboxProps) => (
  <CheckboxPrimitive.Root
    ref={ref} // Pass the ref prop down to the underlying Radix component
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-md border border-primary shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
      // Note: Changed focus-visible:outline-hidden to focus-visible:outline-none as hidden is not a standard value for outline. Use none or Ring for focus indication.
      className,
    )}
    {...props} // Spread the rest of the props
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      {/* Ensure the Check icon's size matches the container if needed */}
      <Check className="w-4 h-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
)

// It's still good practice to set the displayName for debugging purposes.
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
